export default {
noBorderBottom:{},
    large: {},
    short: {},
    contentModule: {
        display: 'flex',
        flexDirection: 'column',
        gap: '15px',
        width: '100%',
    },
    contentModuleRow: {
        display: 'flex',
    },
    contentModuleCell: {
        display: 'table-cell',
        '&$short': {
            width: '35%',
            textAlign: 'right'
        },
        '&$large': {
            width: '65%'
        },
    },
    removeGap: {
        marginTop: '-5px'
    },
    removeGapLarge: {
        marginTop: '-15px'
    }
}